import { Debts } from 'modules/onboarding/common/components';

import { useDebts } from '../hooks';
import { PageComponentProps } from '../types';

export const DebtsStep = ({ canGoBack }: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading, isEntrepreneur } =
    useDebts();

  return (
    <Debts
      canGoBack={canGoBack}
      initialValues={initialValues}
      isEntrepreneur={isEntrepreneur}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
